import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { useAppDispatch, useAppSelector } from "../../../App/hooks";
import {
  IDeltaHedgeOrderFormValues,
  IDeltaHedgeOrderTableReport,
  IDeltaHedgeOrderTablesSearchParam,
} from "../../../Interfaces/deltaHedgeOrder";
import {
  setDeltaHedgeEditFlag,
  setDeltaHedgeOrderFormValues,
  setDeltaHedgeOrderTableFlag,
} from "../../../Features/DeltaHedgeOrder/deltaHedgeOrderSlice";
import { store } from "../../../App/store";
import { getDeltaHedgeOrderTable } from "../../../Requests/deltaHedgeOrder";
import { DeltaHedgeOrderTableAdditional } from "./Additional";
import EditOrder from "../../../Pages/DeltaHedgeOrder/EditOrder";
import Modal from "../../../Components/Modal/Modal";
import { StepOrderSide } from "../../../Interfaces/stepInterfaces";

interface IProps {
  searchParam: IDeltaHedgeOrderTablesSearchParam;
}

const DeltaHedgeOrderTable = ({ searchParam }: IProps) => {
  const flag = useAppSelector(
    (store) => store.deltaHedgeOrder.orderTableFetchDataFlag
  );
  const editFlag = useAppSelector((store) => store.deltaHedgeOrder.editFlag);
  const dispatch = useAppDispatch();

  const tableRowClickHandler = (row: IDeltaHedgeOrderTableReport) => {
    dispatch(
      setDeltaHedgeOrderFormValues({
        ...(store.getState().deltaHedgeOrder?.addOrderFormValues ||
          ({} as IDeltaHedgeOrderFormValues)),
        instrumentId1: row.instrumentIds[0],
        optionOrderType1: row.optionOrderType1,
        orderSide1:
          row.orderSideStr?.split("_")[0]?.trim() === "خرید"
            ? StepOrderSide.Buy
            : StepOrderSide.Sell,
        instrumentId2: row.instrumentIds[1],
        optionOrderType2: row.optionOrderType2,
        orderSide2:
          row.orderSideStr?.split("_")[1]?.trim() === "خرید"
            ? StepOrderSide.Buy
            : StepOrderSide.Sell,
      })
    );
  };

  return (
    <div className="overflow-auto order-table">
      {editFlag ? (
        <Modal title="ویرایش سفارش"
          UI={<EditOrder isConditionId={false} />}
          onClose={() => dispatch(setDeltaHedgeEditFlag(false))}
        />
      ) : (
        <></>
      )}
      <TableTemplate<
        IDeltaHedgeOrderTablesSearchParam,
        IDeltaHedgeOrderTableReport
      >
        refreshTableTime={10000}
        withSort
        getDataTable={getDeltaHedgeOrderTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            withSelect
            reports={reports}
            onAction={() => {
              if (onAction) {
                onAction();
                dispatch(setDeltaHedgeOrderTableFlag(false));
              }
            }}
            onTableRowClick={tableRowClickHandler}
            sortingType={sortingType}
            setSortingType={setSortingType}
            refreshFlag={flag}
            AdditionalBody={DeltaHedgeOrderTableAdditional}
            tableBoxClassName="max-h-[500px] overflow-auto"
          />
        )}
        searchParameters={searchParam}
        showPageSize
      />
    </div>
  );
};

export default DeltaHedgeOrderTable;
